<template>
  <app-layout>
    <template #header>
      <AppHead title="Profile" />
      <h2 class="h4 font-weight-bold">
        Profile
      </h2>
    </template>
    
    <div class="mt-4">
      <update-billing-information-form :payment="payment" :has_linked="has_linked" />
      <jet-section-border />
    </div>

    <div v-if="has_linked">
      <update-linked-settings-form :user="$page.props.auth.user" />

      <jet-section-border />
    </div>

    <div class="mt-4">
      <tax-exempt-form :user="$page.props.auth.user" :file="file" />

      <jet-section-border />
    </div>

    <div v-if="$page.props.jetstream.canUpdateProfileInformation">
      <update-profile-information-form :user="$page.props.auth.user" />

      <jet-section-border />
    </div>

    <div v-if="$page.props.jetstream.canUpdatePassword" class="mb-4">
      <update-password-form />

    </div>

  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import DeleteUserForm from './DeleteUserForm'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm'
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm'
import UpdatePasswordForm from './UpdatePasswordForm'
import UpdateProfileInformationForm from './UpdateProfileInformationForm'
import UpdateBillingInformationForm from './UpdateBillingInformationForm'
import TaxExemptForm from './TaxExemptForm'
import UpdateLinkedSettingsForm from './UpdateLinkedSettingsForm'

export default {
  props: ['file', 'payment', 'has_linked'],

  components: {
    AppLayout,
    DeleteUserForm,
    JetSectionBorder,
    LogoutOtherBrowserSessionsForm,
    TwoFactorAuthenticationForm,
    UpdatePasswordForm,
    UpdateProfileInformationForm,
    UpdateBillingInformationForm,
    TaxExemptForm,
    UpdateLinkedSettingsForm,
  },
}
</script>
